export const USERS_HOTEL_DELIVERY = 'USERS_HOTEL_DELIVERY'
export const USERS_HOTEL_STAFF = 'USERS_HOTEL_STAFF'
